import React from 'react';
import { GenericListPage } from '../../components/generic';
import { useSupportTickets, SupportTicket } from './useData';
import { moduleConfig, getColumns, getToolbarIcon, getTableActions } from './config';

const List: React.FC = () => {
  return (
    <GenericListPage<SupportTicket>
      useData={useSupportTickets}
      config={{
        ...moduleConfig,
        getColumns,
        getToolbarIcon,
        getTableActions,
      }}
    />
  );
};

export default List;

